import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { get } from "../../helpers/api_helpers";
import { config } from "../../config/config";
import { Helmet } from "react-helmet";
import styled from "styled-components";

const BlogDetail = () => {
  const { id } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      if (!id) {
        setLoading(false);
        return;
      }
      try {
        const res = await get(`/blog_details/${id}`);
        setBlog(res?.result || null);
      } catch (err) {
        setError("Blog not found");
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  if (loading) {
    return (
      <div className="main-content" style={{ padding: "2rem", textAlign: "center" }}>
        Loading...
      </div>
    );
  }
  if (error || !blog) {
    return (
      <div className="main-content" style={{ padding: "2rem", textAlign: "center" }}>
        <p>{error || "Blog not found."}</p>
        <Link to="/home">Return Home</Link>
      </div>
    );
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{blog.title || "Blog"} | PetQura</title>
      </Helmet>
      <div className="main-content">
        <ArticleWrap>
          <h1>{blog.title}</h1>
          {blog.image1 && (
            <img
              src={blog.image1}
              alt={blog.title}
              style={{ width: "100%", maxHeight: 400, objectFit: "cover", borderRadius: 12 }}
            />
          )}
          <ContentBody
            dangerouslySetInnerHTML={{ __html: blog.content || blog.content_raw || "" }}
          />
          <Link to="/home" className="backLink">
            ← Back to Home
          </Link>
        </ArticleWrap>
      </div>
    </>
  );
};

export default BlogDetail;

const ArticleWrap = styled.article`
  max-width: 800px;
  margin: 0 auto;
  padding: 2rem 1rem;

  h1 {
    margin-bottom: 1rem;
    color: #333;
  }

  .backLink {
    display: inline-block;
    margin-top: 2rem;
    color: #00419d;
  }
`;

const ContentBody = styled.div`
  margin-top: 1.5rem;
  line-height: 1.6;
  color: #444;

  p {
    margin-bottom: 1rem;
  }
  img {
    max-width: 100%;
    height: auto;
  }
`;
